import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ReferralDataService } from '../../services/referral-data.service';
import { SectionsService } from '../../services/sections.service';
import { AuthorizationUtility } from '../../shared/authorization/auth.utility';
import { AllowListAuthStore } from '../../shared/authorization/allow-list-auth.store';
import { AuthorizeButtonDirective } from '../../shared/authorization/authorizeButton.directive';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { PAGE_CONSTANTS } from '../../shared/constants/page.constants';
import { STATIC_DATA } from '../../shared/constants/static-data.constants';
import { SharedDataService } from '../../shared/services/shared-data-service';
import { ParticipantLeadsListComponent } from '../participant-leads-list/participant-leads-list.component';
import { UserService } from '../../services/user.service';
import { ListService } from '../../shared/services/list.service';

@Component({
  selector: 'ppl-provider-leads-list',
  standalone: true,
  imports: [ListTableComponent, NzIconModule, NzButtonModule, RouterModule, AuthorizeButtonDirective, ButtonComponent],
  templateUrl: './provider-leads-list.component.html',
  styleUrl: './provider-leads-list.component.css'
})
export class ProviderLeadsListComponent extends ParticipantLeadsListComponent {
  override sharedDataKey: string = STATIC_DATA.SHARED_PROVIDER_LEADS_DATA;
  override pageId: string = PAGE_CONSTANTS.PROVIDER_LEADS_DATA_GRID_PAGE;

  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    userService: UserService,
    authUtility: AuthorizationUtility,
    allowListStore: AllowListAuthStore
  ) {
    super(router, sectionService, referralDataService, sharedDataService, userService, authUtility, allowListStore);
  }

  override onNewLead(): void {
    if (this.isReadOnly) return;
    this.sectionService.setFlow('providers');
    this.referralDataService.clearReferrralData();
    this.router.navigate(['/referralLogic']);
  }

  override rowClicked(rowDetail: any) {
    console.log(rowDetail);
    
    this.userService.setLeadEntry('provider');
    this.sectionService.setFlow('provider');
    this.userService.setSelectedLead(rowDetail.lead_id);
    setTimeout(() => {
      this.router.navigate(['/home/providerLeadsList/leadDetails/']);
    }, 200)

    
  }
}
